import React, { memo } from 'react';
import { Box, Container, Flex, Grid, GridItem, Heading, Link, Stack, Text } from '@chakra-ui/react';
import { FaFacebook, FaInstagram, FaTwitter, FaPinterest } from 'react-icons/fa';
import { motion } from 'framer-motion';
import { Link as RouterLink } from 'react-router-dom';

const MotionBox = motion(Box);
const MotionLink = motion(Link);

const Footer = memo(() => {
  return (
    <MotionBox 
      bg="black" 
      color="white" 
      py={{ base: 8, md: 12 }}
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.6 }}
    >
      <Container maxW="container.xl">
        <Grid 
          templateColumns={{ base: '1fr', md: '2fr 1fr 1fr' }} 
          gap={{ base: 8, md: 16 }}
          textAlign={{ base: 'center', md: 'left' }}
        >
          <GridItem>
            <Heading 
              as="h2" 
              size={{ base: '4xl', md: '4xl' }} 
              mb={4}
              fontWeight="normal"
              lineHeight="shorter"
              fontFamily="'Cormorant', serif"
            >
              Let's Talk
            </Heading>
            <Text fontSize={{ base: 'md', md: 'lg' }} mb={4}>
              Have a project in mind or just want to say hello? Feel free to reach out!
            </Text>
            <MotionLink 
              href="mailto:info@agnir.com" 
              fontSize={{ base: 'md', md: 'lg' }} 
              fontWeight="bold"
              whileHover={{ color: "gray.300", x: 5 }}
              display="inline-block"
            >
              agnir.info@gmail.com
            </MotionLink>
          </GridItem>

          <GridItem>
            <Heading as="h3" size="3xl"  fontFamily="'Cormorant', serif" mb={4}>Agnir</Heading>
            <Text mb={2}>For the ones who wear presence | Modern Jewelry | India</Text>
            <Flex mt={4} justify={{ base: 'center', md: 'flex-start' }}>
              <MotionLink href="https://www.instagram.com/agnir.co?igsh=MW5mYmJiZ2VnYjlyYg==" mx={1} whileHover={{ y: -2 }}><FaInstagram size="20px" /></MotionLink>
              {/* <MotionLink href="#" mx={1} whileHover={{ y: -2 }}><FaTwitter size="20px" /></MotionLink> */}
              {/* <MotionLink href="#" mx={1} whileHover={{ y: -2 }}><FaPinterest size="20px" /></MotionLink> */}
            </Flex>
          </GridItem>

          <GridItem>
            <Flex direction={{ base: 'row', md: 'column' }} justify={{ base: 'space-around', md: 'flex-start' }} wrap="wrap" gap={8}>
              <Box>
                <Heading as="h3" size="md" mb={4}>Shop</Heading>
                <Stack spacing={2}>
                  <MotionLink as={RouterLink} to="/products/rings" whileHover={{ x: 2 }}>Rings</MotionLink>
                  <MotionLink as={RouterLink} to="/products/bracelets" whileHover={{ x: 2 }}>Bracelets</MotionLink>
                  <MotionLink as={RouterLink} to="/products/pendants" whileHover={{ x: 2 }}>Pendants</MotionLink>
                  <MotionLink as={RouterLink} to="/products/chains" whileHover={{ x: 2 }}>Chains</MotionLink>
                </Stack>
              </Box>
              <Box>
                <Heading as="h3" size="md" mb={4}>Customer Service</Heading>
                <Stack spacing={2}>
                  <MotionLink as={RouterLink} to="/about-us" whileHover={{ x: 2 }}>About Us</MotionLink>
                  <MotionLink as={RouterLink} to="/contact" whileHover={{ x: 2 }}>Contact Us</MotionLink>
                  <MotionLink as={RouterLink} to="/faqs" whileHover={{ x: 2 }}>FAQs</MotionLink>
                </Stack>
              </Box>
            </Flex>
          </GridItem>
        </Grid>

        <Flex 
          justify={{ base: "center", md: "space-between" }} 
          align={{ base: "center", md: "center" }}
          direction={{ base: "column", md: "row" }}
          mt={{ base: 10, md: 20 }}
          gap={{ base: 4, md: 0 }}
        >
          <Text fontSize={{ base: "sm", md: "md" }}>&copy; {new Date().getFullYear()} Agnir. All rights reserved.</Text>
          <Flex gap={6} direction={{ base: "column", sm: "row" }} align="center">
            <MotionLink 
              as={RouterLink} 
              to="/privacy-policy" 
              fontSize={{ base: "sm", md: "md" }}
              whileHover={{ x: 2 }}
              _hover={{ textDecoration: "underline" }}
            >
              Privacy Policy
            </MotionLink>
            <MotionLink 
              as={RouterLink} 
              to="/terms-conditions" 
              fontSize={{ base: "sm", md: "md" }}
              whileHover={{ x: 2 }}
              _hover={{ textDecoration: "underline" }}
            >
              Terms & Conditions
            </MotionLink>
          </Flex>
        </Flex>
      </Container>
    </MotionBox>
  );
});

export default Footer;